<template>
  <v-container fluid class="product-list px-0">
    <div class="header">
      <div class="text-h5 pl-2">商品</div>
      <v-btn color="primary" @click="onCreate">创建商品</v-btn>
    </div>
    <v-list>
      <v-list-item-group color="primary">
        <v-list-item class="list-item" v-for="item in list" :key="item.id" @click="onClickItem(item.id)">
          <v-row align="center" justify="space-between">
            <v-col cols="4">{{ item.name }}</v-col>
            <v-col cols="8" class="product-info">
              <div class="product-onsale" :class="{ 'active': item.is_onsale }">{{ item.is_onsale ? '在售' : '不在售' }}</div>
              <div class="product-redeem" :class="{ 'active': item.is_redeem }">{{ item.is_redeem ? '可兑换' : '不可兑换' }}
              </div>
              <div class="product-price">{{ getPrice(item) }}</div>
            </v-col>
          </v-row>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-container>
</template>

<script>
import { productStore } from '@/store/product'
import { priceTableStore } from '@/store/priceTable'
import { formatCurrency, formatPrice } from '@/plugins/price'

export default {
  computed: {
    list() {
      return productStore.list
    },
  },
  methods: {
    onCreate() {
      this.$router.push('/dash/product-detail')
    },
    onClickItem(id) {
      this.$router.push({
        path: '/dash/product-detail',
        query: { id },
      })
    },
    getPrice(product) {
      let price = priceTableStore.getPrice({ tier_key: product.price_tier_key })
      let priceStr = formatPrice(price, priceTableStore.main_currency)
      let currencyStr = formatCurrency(priceTableStore.main_currency)
      return `${priceStr} ${currencyStr}`
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/styles/common';

.product-list {
  .header {
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: space-between;
  }

  .product-info {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .product-price {
    flex: 1;
    text-align: right;
  }

  .product-onsale,
  .product-redeem {
    margin-left: 8px;
    font-size: 13px;
    padding: 0 4px;
    border-radius: 6px;
    border: solid 1px @antTextGrey;
    color: @antTextGrey;

    &.active {
      border-color: @antGreen;
      color: @antGreen;
    }
  }
}
</style>
